import React from 'react'
import './TPFooter.scss'
import STYLE from '../../base'

import TPLogo from '../TPLogo/TPLogo'

const Footer = () => (
  <footer className="page-footer">
    <a href="/" className="logo"><TPLogo primaryColor={STYLE.colors.neutral} secondaryColor={STYLE.colors.secondary} width="160"/></a>
    <span className="tag-line">Better business loans</span>
    <span className="social-links">
      <a className="facebook" href="https://www.facebook.com/truepillars.au">
        <img src="//images.ctfassets.net/mw30n3wq3nc0/6l0Ih5cx1IWu4PQp4tbYkE/552358a08a77c1aed8b23ffc1c5f9cf8/icon-facebook.svg" alt="facebook"/>
      </a>
      <a className="twitter" href="https://twitter.com/TruePillars">
        <img src="//images.ctfassets.net/mw30n3wq3nc0/64pKg1KFE6aclSBQ7KJiW2/625425d7f45c35e9fc7a6616c492e550/icon-twitter.svg" alt="twitter"/>
      </a>
      <a className="instagram" href="https://www.instagram.com/truepillars/">
        <img src="//images.ctfassets.net/mw30n3wq3nc0/5RZcoHRlBEahOQGkoJyhmL/e2e2bd6cef5ed2c2d54a9fe7ecb9818d/icon-instagram.svg" alt="instagram"/>
      </a>
      <a className="linkedin" href="https://www.linkedin.com/company/truepillars-pty-ltd/">
        <img src="//images.ctfassets.net/mw30n3wq3nc0/2Huq17CH06Cs4wdku1ABHZ/17e9f8373d7dee0d20493e259a4b884f/icon-linkedin.svg" alt="linkedin"/>
      </a>
    </span>
  </footer>
)

export default Footer
